import React from 'react';


const Header= props => {
    const {search,inputChange,onSearchClick}=props;
    return (
        <div className="jumbotron"> 
        <div className="name">
        <h1 className="display-1">
        <i className="material-icons brand-icons">
        search
    </i>
            Food Recipes</h1>
            </div>
            <nav className="navbar  sticky-top navbar-expand-lg navbar-light bg-light p-1">
            <a  className="navbar-brand" href="#"><img  className="rounded-circle p-0 m-0" src="https://img.freepik.com/free-vector/letter-s-with-spoon-fork-logo-tableware-logo-fast-food-restaurant-logo_65373-25.jpg?size=338&ext=jpg" alt="logo" height="60px" width="100%" /></a>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
  <div className="container-fluid">
      
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="#">Home</a>
        </li>
       
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Food Categories
          </a>
          <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><a className="dropdown-item" href="#">Banana</a></li>
            <li><a className="dropdown-item" href="#">Chicken</a></li>
           
            <li><a className="dropdown-item" href="#">Orange</a></li>
            <li><a className="dropdown-item" href="#">Appetizers,Beverages</a></li>
            <li><a className="dropdown-item" href="#">Soups</a></li>
            <li><a className="dropdown-item" href="#">Salads</a></li>
            <li><a className="dropdown-item" href="#">Desserts</a></li>
            <li><a className="dropdown-item" href="#">Miscallaneous</a></li>
          </ul>
        </li>
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="#">AboutUs</a>
        </li>
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="#">Login</a>
        </li>
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="#">SignUp</a>
        </li>
        
      </ul>
      
     <div className="d-flex">
        <input type="text" className="form-control me-2" placeholder="Search Recipe..." value={search} onChange={inputChange}/>
            <button className="btn btn-dark" onClick={onSearchClick} value={search}>Search</button>

        </div>
    </div>
  </div>
</nav>
            
          
              
          
        
          
           
            </div>
        
         
    
    );
}

export default Header;